import ApiClient from "../../../apiClient";
import { BASE_URL, CUSTOMERS, SEARCH } from "../../../constant/apiEndPoint";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getCustomerAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${CUSTOMERS.getAllCustomers}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_CUSTOMER_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_CUSTOMER_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const deactivateCustomerAction = (payload, customer_id, navigate, customerPayload) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.put(`${BASE_URL}${CUSTOMERS.deactivateCustomer}=${customer_id}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        // CustomToast({
        //   type: "success",
        //   message: response.data.result.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
        dispatch({ type: TYPE.ACTIVATE_DEACTIVATE_CUSTOMER_SUCCESS, payload: response.data.result.message });
        dispatch(getCustomerAction(customerPayload, navigate));
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          // CustomToast({
          //   type: "error",
          //   message: "Session expired, please login again",
          //   options: { autoClose: 5000, position: "top-center" },
          // });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.ACTIVATE_DEACTIVATE_CUSTOMER_FAIL, payload: error?.data?.result?.message });
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getCustomerByIdAction = (emp_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${CUSTOMERS.getCustomerById}=${emp_id}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_CUSTOMER_BY_ID_SUCCESS,
          payload: response.data.result.data,
        });
        // navigate("/dashboard");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({ type: TYPE.GET_CUSTOMER_BY_ID_FAIL, payload: error?.data?.result?.message });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
        // navigate("/dashboard");
      });
  };
};

export const updateCustomerAction = (payload, emp_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${CUSTOMERS.updateCustomerById}=${emp_id}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        // CustomToast({
        //   type: "success",
        //   message: response.data.result.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
        dispatch({
          type: TYPE.UPDATE_CUSTOMER_SUCCESS,
          payload: response.data.result.message,
        });
        // dispatch(getCustomerAction({}, navigate));
        navigate("/customers");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.UPDATE_CUSTOMER_FAIL, payload: error.data.result.message });
        if (error.status === 500) {
          CustomToast({
            type: "error",
            message: "Internal Server Error",
            options: { autoClose: 5000, position: "top-center" },
          });
          return;
        }
        if (error.status === 419) {
          // CustomToast({
          //   type: "error",
          //   message: "Session expired, please login again",
          //   options: { autoClose: 5000, position: "top-center" },
          // });
          checkSession(dispatch, navigate);
          return;
        }
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getFilteredCustomerAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${SEARCH.ADMIN_SEARCH}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_CUSTOMER_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.GET_CUSTOMER_FAIL, payload: [] });
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};
